<template>
    <div class="container">
      <div class="top">
          <div class="welcome">
            <br />
            <span class="welcome-message">BIENVENUE | WILLKOMMEN | WELKOM | WELCOME | BIENVENIDO</span>
        <img class="logo" src="../assets/images/logo.png">

          <div class="content">
            <div id="element" class="lang-content" >
                  <p>Sélectionnez votre pays | Wählen Sie Ihr Land | Kies je land | Select your country | Selecciona tu pais</p>

                <div class="choose-lang">
                  <!-- <div class="off">
                    <router-link to="/form/FR_fr"><img class="off" src="../assets/images/france.png"></router-link>
                    <router-link to="/form/FR_fr" >France</router-link>
                  </div> -->
                  <div v-if="pays_fr">
                    <router-link to="/form/FR_fr"><img src="../assets/images/france.png"></router-link>
                    <router-link to="/form/FR_fr" >France</router-link>
                  </div>        
                  <div class="off" v-if="!pays_fr">
                    <a><img class="off"  src="../assets/images/france.png"></a>
                    <a>France</a>
                  </div>                              
                  <div v-if="pays_be1">
                    <a @click="selectRoute('BE')"><img src="../assets/images/belgium.png"></a>
                    <router-link to="/form/BE_nl">België</router-link>
                    &nbsp;/
                    <router-link to="/form/BE_fr">Belgique</router-link>
                  </div>
                   <div class="off" v-if="!pays_be1">
                    <a><img class="off"  src="../assets/images/belgium.png"></a>
                    <a>België</a>
                    &nbsp;/
                    <a>Belgique</a>
                  </div>                 
                  <div  v-if="pays_de">
                    <router-link to="/form/DE_de"><img src="../assets/images/germany.png"></router-link>
                     <router-link to="/form/DE_de">Deutsch</router-link>
                  </div>
                   <div class="off" v-if="!pays_de" >
                    <a><img class="off"  src="../assets/images/germany.png"></a>
                    <a>Deutschland</a>
                  </div>                 
                  <div v-if="pays_nl">
                    <router-link to="/form/NL_nl"><img  src="../assets/images/netherlands.png"></router-link>
                    <router-link to="/form/NL_nl">Nederland</router-link>
                  </div>
                   <div v-if="!pays_nl" class="off">
                    <a><img class="off" src="../assets/images/netherlands.png"></a>
                    <a>Nederland</a>
                  </div>                 
                  <div v-if="pays_lux1">
                    <router-link to="/form/LU_fr"><img src="../assets/images/luxembourg.png"></router-link>
                    <router-link to="/form/LU_nl">Lëtzebuerg</router-link>
                    &nbsp;/<router-link to="/form/LU_fr">Luxembourg</router-link>
                  </div>
                  <div class="off"  v-if="!pays_lux1">
                    <a><img  class="off"  src="../assets/images/luxembourg.png"></a>
                    <a>Lëtzebuerg</a>
                    &nbsp;/<a>Luxembourg</a>
                  </div>
                  <div  v-if="pays_es">
                    <router-link to="/form/ES_es"><img src="../assets/images/spain2.png"></router-link>
                     <router-link to="/form/ES_es">España</router-link>
                  </div>
                   <div class="off" v-if="!pays_es" >
                    <a><img class="off"  src="../assets/images/spain2.png"></a>
                    <a>España</a>
                  </div>
                </div>            
          </div>          
          </div>
          </div>

      </div>
  <br />&nbsp;<br />
  </div>
</template>
<script>
import Vue from 'vue'
import axios from "axios";


export default {
  name: 'home',
    data: function() {
      return {
        userlang : navigator.language || navigator.userLanguage,
        pays_fr : false,
        pays_de : false,
        pays_lux1 : false,
        pays_lux2 : false,
        pays_be1 : true,
        pays_be2 : true,
        pays_nl : false,                                                
        pays_es : false,                                                
      }
    },
    async mounted() {

      let { data }  = await  this.getData()
     // console.log(data, '--------------------------')

      for (const element of data) {

        if(this.checkDate(element.date_debut, element.date_fin) == false)
        {

          if(element._id == "5f4653adc81e900017aeea02") {
              //this.pays_lux1 = false    
          }

          if(element._id == "5f465765c81e900017aeea15") {
              //this.pays_lux1 = false    
          }

          if(element._id == "601c0557f040b60015d3a2b8") {
              //this.pays_nl = false
          }

          if(element._id == "6038d4a6344be000154aa2c7") {
              //this.pays_de = false
          }   

          if(element._id == "601762d938ad29fed023cada") {
              //this.pays_fr = false
          }     
        }
      }


      window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
      ga('create', 'UA-123759092-29', 'auto');
      ga('send', 'pageview');
    },
    methods : {
      checkDate :  function( date_debut, date_fin ) {
        var dt = new Date()      
        var a = new Date(date_debut);
        var b = new Date(date_fin);
        var inRange = dt >= a && dt <= b;   
        return inRange;
      },
      getData : function () {
        return axios.get(
          "https://api.mypromodistrigo.com/api/getoperations/PSA"
        );
      },
      selectRoute(lang) {
        if(lang == 'BE') {
           if(this.userlang == 'fr-BE') this.$router.push('/form/BE_fr');
           else if(this.userlang == 'nl-BE') this.$router.push('/form/BE_nl');
           else this.$router.push('/form/BE_fr');
        }
        if(lang == 'LU') {
           if(this.userlang == 'fr-LU') this.$router.push('/form/LU_fr');
           else if(this.userlang == 'nl-LU') this.$router.push('/form/LU_nl');
           else this.$router.push('/form/LU_fr'); 
        }
      }
    }
}
</script>